import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { SvgWhatsappIcon, PhoneIcon } from '@images/svg';
import {
  py, px, mb, mt, mr, mx
} from 'styled-components-spacing';

import theme from '@theme';

const { colors } = theme;

export const StyledThanksWrapper = styled.div`
  display: flex;
  width: ${props => (props.treatmentFormName || props.isModal ? '95%' : 'calc(100% - 1rem)')};
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  color: ${colors.white};
  background-color: ${props => (props.treatmentFormName ? 'transparent' : colors.white)};
  border-radius: 8px;

  ${breakpoint('mobile', 'desktop')`
    ${props => (props.treatmentFormName || props.isModal ? px(0) : px(3))}
    ${props => (props.treatmentFormName || props.isModal ? py(0) : py(5))}
    ${props => (props.treatmentFormName || props.isModal ? mb(0) : mb(5))}
    ${props => (props.treatmentFormName || props.isModal ? mt(0) : mt(3))}
    ${props => (props.treatmentFormName || props.isModal ? mx(0) : mx(2))}
    ${props =>
    props.isModal
      && `width: 90%;
       margin: 0 auto;
    `}
  `}

  ${breakpoint('desktop')`
    color: ${colors.darkBlue};
    ${props => props.treatmentFormName && 'margin: 0 auto'};
  `}
`;

export const StyledThanksTitle = styled.div`
  font-size: ${props => (props.treatmentFormName ? '18px' : '40px')};
  font-size: ${props => props.isModal && '30px'};
  line-height: 2rem;
  font-weight: 700;
  color: ${props => (props.treatmentFormName ? colors.white : colors.navyGray)};
  width: 100%;
  text-align: center;
  ${mb(3)}

  ${props => props.isModal && mt(3)}

  ${breakpoint('mobile', 'desktop')`
    font-size: 28px; 
  `}
`;

export const StyledCompletedWrapper = styled.div`
  width: ${props => (props.isModal ? '40%' : '30%')};
  align-self: center;

  ${breakpoint('mobile', 'desktop')`
    width: ${props => (props.isModal ? '70%' : '50%')};
  `}
`;

export const StyledThanksSubtitle = styled.div`
  line-height: 2rem;
  font-weight: 600;
  font-size: ${props => (props.treatmentFormName ? '16px' : '22px')};
  font-size: ${props => props.isModal && '20px'};
  text-align: center;
  align-self: center;
  ${props =>
    (props.slide === 3
      ? `
  font-weight: 700;`
      : `
  margin-top: 12px;
  margin-bottom: 32px;
  `)}

  ${props => props.treatmentFormName && 'margin-top: 22px'};
  ${props => (props.treatmentFormName || props.isModal) && 'margin-bottom: 22px'};
  ${props => props.treatmentFormName && px(2)}
  color: ${props => (props.treatmentFormName ? colors.white : colors.navyGray)};

  ${breakpoint('mobile', 'desktop')`
    font-size: 16px;
  `}
`;

export const StyledDragDropBottomSection = styled.div`
  width: 90%;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${props => (props.treatmentFormName ? '16px' : '32px')};
  padding-top: ${props => (props.treatmentFormName ? '16px' : '32px')};
  border-top: 2px solid
    ${props => (props.treatmentFormName ? colors.white : colors.translucentDarkBlue)};
`;

export const StyledDragDropBottomHeadline = styled.span`
  font-size: ${props => (props.treatmentFormName ? '18px' : '22px')};
  font-weight: 700;
  color: ${props => (props.treatmentFormName ? colors.white : colors.navyGray)};
`;

export const StyledContactIconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const StyledWhatsappIcon = styled(SvgWhatsappIcon)`
  ${mr(4)}
  height: 30px;
  width: 30px;
`;

export const StyledPhoneIcon = styled(PhoneIcon)`
  ${mr(4)}
  height: 30px;
  width: 30px;
`;
